import { Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DropdownSingleSelect } from "../DropdownSingleSelect";
import { NavigationTabs, Tab } from "../NavigationTabs";

export type BuildingProfileFileSection = {
  name: BuildingProfileFileSectionName;
};

export type BuildingProfileFileSectionName = "3D Models" | "Building Plans" | "Document" | "Other" | "Reports";

export const buildingProfileFilesSections: BuildingProfileFileSection[] = [
  {
    name: "Document",
  },
  {
    name: "Building Plans",
  },
  {
    name: "3D Models",
  },
  {
    name: "Reports",
  },
  {
    name: "Other",
  },
];

export const useBuildingProfileTableFilesSectionSelection = () => {
  const [selectedTab, setSelectedTab] = useState(buildingProfileFilesSections[0]);
  const [selectedFileSection, setSelectedFileSection] = useState(selectedTab.name);

  useEffect(() => {
    setSelectedFileSection(selectedTab.name);
  }, [selectedTab]);

  return {
    selectedFileSection,
    selectedTab,
    setSelectedFileSection,
    setSelectedTab,
  };
};

export const BuildingProfileTableFilesSectionSelection = ({
  selectedFileSection,
  setSelectedFileSection,
}: {
  selectedFileSection: string;
  setSelectedFileSection: (value: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Stack className=" mt-6 w-full flex-col items-start gap-2">
      <h3 className="font-ds-number-regular-sm">{t("BuildingProfile.table.fileSections.fileSection")}</h3>
      <DropdownSingleSelect
        className="w-full"
        displayOptions={buildingProfileFilesSections.map((section) =>
          t(`BuildingProfile.table.fileSections.${section.name}`)
        )}
        label={t("BuildingProfile.table.fileSections.fileSection")}
        options={buildingProfileFilesSections.map((section) => section.name)}
        selectedValue={selectedFileSection}
        setSelectedValue={(value?: string) => setSelectedFileSection(value ?? buildingProfileFilesSections[0].name)}
      />
    </Stack>
  );
};

export const BuildingProfileTableTabs = ({
  selectedTab,
  setSelectedTab,
}: {
  selectedTab: Tab;
  setSelectedTab: (value: Tab) => void;
}) => {
  const { t } = useTranslation();

  const translatedFileSections = buildingProfileFilesSections.map((fileType) => ({
    displayName: t(`BuildingProfile.table.fileSections.${fileType.name}`),
    name: fileType.name,
  }));

  return <NavigationTabs activeTab={selectedTab} setActiveTab={setSelectedTab} tabs={translatedFileSections} />;
};
